<template>

<app-content :loading="is.loading">

	<app-content-body>

		<div class="qrcode">

            <div class="qrcode-image">
                <qrcode-vue foreground="#21262e" :value="subscription.id" level="H" size="1024" />
            </div>

            <div class="qrcode-text">
                Scan your QR code on entry to verify your membership.
            </div>

        </div>

		<div class="summary-wrapper">

            <app-content-summary :grow="true">

                <app-content-summary-item label="Membership" :grow="true" :value="subscription.type.name" />
				<app-content-summary-item label="Total Checkins" :value="subscription.count.checkins" />
				<app-content-summary-item v-if="subscription.date.checkin" label="Last Checkin" :value="subscription.date.checkin | localDate('MM/DD/YYYY')" />
				<app-content-summary-item v-if="!subscription.date.checkin" label="Last Checkin" value="n/a" />

			</app-content-summary>

        </div>

	</app-content-body>

</app-content>

</template>

<script>

import Vue from 'vue'
import QrcodeVue from 'qrcode.vue'

export default {

    components: {
        QrcodeVue
    },

	data: function() {

		return {
			is: {
				loading: true
			},
            subscription: {}
		}

	},

	created: function() {

		this.load()

	},

    computed: {
    
        isActive: function() {
		
			return this.subscription.status === 1
		
		},

		isCancelled: function() {
		
			return this.subscription.status === 2
		
		},

		isExpiring: function() {
		
			return this.subscription.status === 3
		
		}

    },

	methods: {

		load: function() {

			this.$api.get('membership/dashboard').then(function(json) {

                Vue.set(this, 'subscription', json.subscription)

				this.is.loading = false

			}.bind(this))

		}

	}

}

</script>

<style scoped>

.qrcode {
    background-color: #fff;
    border-radius: 4px;
    width: 100%;
    border: 1px solid #eee;
    display: flex;
    align-items: center;
    flex-direction: column;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px;
}

.qrcode >>> canvas {
    max-width: 240px;
    width: 100%!important;
    height: auto!important;
}

.is-mobile .qrcode >>> canvas {
    max-width: 180px;
}

.qrcode-image {
    padding: 20px;
}

.qrcode-text {
    border-top: 1px solid #eee;
    padding: 20px;
    width: 100%;
    text-align: center;
    font-size: 16px;
    color: #343434;
    font-weight: 500;
}

.summary {
    margin-right: 0px!important;
}

.summary-wrapper {
	display: flex;
    margin-top: 20px;
}

.is-mobile .summary-wrapper {
    flex-direction: column;
}

.is-mobile .summary-wrapper >>> .box {
    margin-right: 0px;
}

</style>